module.exports = __webpack_public_path__ + "static/media/9@3x.f9e383a5.png";